import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

const IdentifikasiAkses = () => {
  const location = useLocation();
  const phonenumber = location.state?.phonenumber || '';
const navigate = useNavigate();
  
  const [nama, setNama] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun

  const [formdata, setFormData] = useState({
    npsn:'',
    kode_akses:'',
    noi:''
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(``);
    // Pastikan formdata tidak null atau undefined
    if (!formdata || Object.keys(formdata).length === 0) {
        setError('Data tidak boleh kosong');
        return;
    }
    console.log(formdata)

    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/users/register_kode_akses2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`, // Kirim token di header Authorization
            },
            body: JSON.stringify(formdata),
        });
 const result = await response.json();
        if (!response.ok) {
            throw new Error(result.message);
        }

       

        // Update token jika diberikan oleh server
        if (result.token) {
            localStorage.setItem('authToken', result.token);
        }

        navigate('/admin'); // Arahkan ke halaman admin setelah sukses
    } catch (error) {
        setError(`Terjadi kesalahan: ${error.message}`);
    }
};

  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.name]: e.target.value });
  };

   useEffect(() => {
      const getInformasiAkun = async () => {
        console.log(localStorage.getItem('authToken'))
  
        const authToken = localStorage.getItem('authToken');
  
        if (!authToken) {
          console.error("Token required");
          return; // Jika tidak ada token, hentikan eksekusi
        }
  
        try {
          // Decode payload dari token JWT
          const decoded = jwtDecode(authToken);
          setInformasiAkun(decoded); // Simpan informasi akun ke state
  
  
          if(decoded.akses==null){
            navigate('/daftar/identifikasiakses'); 
          }
        } catch (error) {
          
          return;
        }
      };
      getInformasiAkun();
    }, []);


  return (
    <div>
      <div className="auth-main">
        <div className="auth-wrapper v3">
          <div className="auth-form">
            <div className="card my-5">
              <div className="card-body">
                <a href="#" className="d-flex justify-content-center">
                  <img src="/assets/images/logogvfix.png" alt="image" width={200} className="img-fluid brand-logo" />
                </a>
                <div className="row">
                  <div className="d-flex justify-content-center">
                    <div className="auth-header">
                      <h2 className="text-secondary mt-5"><b>Hi. {informasiAkun?.nama||""}</b></h2>
                      <p className="f-16 mt-2">Kami Belum Bisa Mengidentifikasi Akun Anda, Jadii Untuk Melanjutkan Silahkan isi Informasi Berikut ini</p>
                    </div>
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-floating mb-3">
                    <input 
                      type="text"
                      name='npsn'
                      required
                      value={formdata.nspn}
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                      placeholder="NPSN" 
                    />
                    <label htmlFor="floatingNama">NPSN Sekolah</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input 
                      type="text"
                      name='kode_akses'
                      required
                      value={formdata.kode_akses}
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                     
                      placeholder="Kode Registrasi" 
                    />
                    <label htmlFor="floatingNama">Reg Kode</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input 
                      type="text"
                      value={formdata.noi}
                      name='noi'
                      required
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                      placeholder="No Induk Pegawai" 
                    />
                    <label htmlFor="floatingNama">No Induk Pegawai</label>
                  </div>
                  
                 
                  <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-secondary">Lanjutkan</button>
                  </div>
                </form>

                {error && <div className="alert alert-danger mt-2">{error}</div>}
                {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}

                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdentifikasiAkses;
